// WebSocket 預設版號
const WebSocket_value_win = '1.3.3.4';
const beta_WebSocket_value_win = '1.3.3.4';
const WebSocket_value_mac = '1.2.3mac';
const beta_WebSocket_value_mac = '1.2.3mac';

// 檢查支援 OS 系統
export const checkOS = (osName) => osName == 'Windows' || osName == 'Mac'

// 給 OS 支援的版號
export const getCurrentVersion = (osName) => {
    if (osName == 'Windows') { return [WebSocket_value_win, beta_WebSocket_value_win] }
    else if (osName == 'Mac') { return [WebSocket_value_mac, beta_WebSocket_value_mac] }
    else { return ["NVL", "NVL"] }
}

//只有用判斷IE瀏覽器 < IE10 不能使用
export const checkBrowser = (browserName, browserVersion) => !(browserName === "IE" && Number(browserVersion) < 10)

//檢查WebSocket版本  正式版 與 beta 都可以
export const versionOld = (local_WebSocket_value, osName) => (
    local_WebSocket_value < getCurrentVersion(osName)[0].replace('mac', '') &&
    local_WebSocket_value < getCurrentVersion(osName)[1].replace('mac', '')
)


export const WebSocketTest = (url, onopen, onmessage, onerror) => {
    if (!("WebSocket" in window)) {
        alert("This browser does not support WebSockets."); return;
    }
    var ws = new WebSocket('wss://localhost:9991/ws/' + url);
    // 成功找到元件，ws.send(JSON.stringify(params)) 發資料 會進入 onmessage
    ws.onopen = onopen(ws);
    ws.onmessage = onmessage(ws);
    // 找不到元件
    ws.onerror = onerror(ws);
}
